import React, { ReactElement, useContext, useEffect } from 'react';
import { FieldRendererProps } from '../FieldTableTypes';
import { FieldTableSettingsContext } from '../../../contexts/field-table-settings-context';
import {StopCircle} from "@mui/icons-material";
import { IconButton} from "@mui/material";

export function FieldTableExcluderColumn(): ReactElement {
    const context = useContext(FieldTableSettingsContext);
    useEffect(() => {
        context.registerType({
            dataType: 'excluder',
            width: () => 'min-content',
            className: () => 'column-centered column-button',
            noExport:true,
            readOnly:true,
            renderViewer: (props: FieldRendererProps<any,any>) => {
                return (<IconButton size="small" className="uneditable" onClick={() => props.toggleExclusion?.()}><StopCircle/></IconButton>);
            }
        });
    }, [context]);
    return null;
}
